export function triggerMouseEvent(node: HTMLElement, eventType: string) {
  if (node == null || eventType.length === 0) {
    throw new Error("Invalid arguments");
  }
  const mouseEvent = new MouseEvent(eventType, {
    bubbles: true,
    cancelable: true,
  });

  node.dispatchEvent(mouseEvent);
}
